import React, { useEffect, useMemo } from "react";

import { FormBuilder, Modal } from "shared/components";
import { IAPIState, IFormSchema } from "shared/types";
import { copy } from "shared/assets";
import { User } from "shared/assets/icons";
import { AUTH_ACTIONS, IAuthActions, IChangePassword } from "Auth/types";
import { useStateActionMeta } from "Auth/utils";
import { makeSchema } from "./formData";

interface ChangePasswordProps {
  title?: string;
  metaKey: IAuthActions;
  handleClose: () => void;
  onSubmit: ({ oldPassword, newPassword }: IChangePassword) => void;
}

export const ChangePassword: React.FC<ChangePasswordProps> = ({
  title = copy.changePassword.title,
  metaKey,
  onSubmit,
  handleClose,
}) => {
  const meta = useStateActionMeta(metaKey);

  const schema: IFormSchema = useMemo(
    () => makeSchema(metaKey === AUTH_ACTIONS.changePassword, handleClose),
    [handleClose, metaKey]
  );

  useEffect(() => {
    if (meta?.status === IAPIState.succeeded) {
      handleClose();
    }
  }, [handleClose, meta]);

  return (
    <Modal icon={User} title={title}>
      <FormBuilder
        {...schema}
        onSubmit={onSubmit}
        isSubmitting={meta?.status === IAPIState.pending}
        apiErrorMessage={
          meta?.error ? (meta?.message ? meta.message.body : true) : false
        }
        apiError={meta?.error}
      />
    </Modal>
  );
};
